import { Component, Input } from '@angular/core';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  @Input() message: string = '';

  constructor(private userService: UserService) {}

  isMenuOpen(): boolean {
    return this.userService.isMenuOpen;
  }
}
